import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
  getZeeFinancial,
  GetZeeFinancialApiResponse,
} from '@/actions/zee-financial/getZeeFinancial';
import { ApiResponse } from '@/types/response.type';

export interface UseGetZeeFinancialReturn {
  result: ApiResponse<GetZeeFinancialApiResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetZeeFinancial = (): UseGetZeeFinancialReturn => {
  const query: UseQueryResult<
    ApiResponse<GetZeeFinancialApiResponse> | undefined,
    Error
  > = useQuery({
    queryKey: ['zee-financial'],
    queryFn: getZeeFinancial,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
